import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import Modal from '../../../components/Modal/Modal';
import { AppButton } from '../../../components/UI';
import { asArray, linkedinUrl } from '../utils';
import DuplicateCandidates, { useDuplicateCheck } from '../../../components/DuplicateCandidates/DuplicateCandidates';

const FIELDS = [
  { key: 'linkedin', label: 'LinkedIn', full: true },
  { key: 'prenom', label: 'Prénom' },
  { key: 'nom', label: 'Nom' },
  { key: 'email', label: 'Email' },
  { key: 'telephone', label: 'Téléphone' },
  { key: 'fonction', label: 'Fonction' },
  { key: 'employeur', label: 'Employeur' },
  { key: 'localisation', label: 'Localisation' },
  { key: 'ecole', label: 'École' },
  { key: 'date_debut', label: 'Année de début' },
];

const buildForm = (c) => {
  const parts = String(c?.full_name || '').trim().split(/\s+/);
  return {
    linkedin: linkedinUrl(c) || '',
    prenom: parts[0] || '',
    nom: parts.slice(1).join(' '),
    fonction: asArray(c?.roles_held)[0] || '',
    employeur: c?.employer || '',
    ecole: c?.school || '',
    localisation: c?.location || '',
    email: c?.email || '',
    telephone: c?.phone || '',
    date_debut: c?.latest_experience_year ? String(c.latest_experience_year) : '',
  };
};

const AddToCrmModal = ({ open, candidate, loading, onClose, onSubmit }) => {
  const [form, setForm] = useState(() => buildForm(candidate));

  useEffect(() => {
    if (open) setForm(buildForm(candidate));
  }, [open, candidate]);

  const duplicates = useDuplicateCheck(
    { linkedin: form.linkedin, prenom: form.prenom, nom: form.nom, employeur: form.employeur },
    open,
  );
  const submitLabel = duplicates.sameProfile ? 'Mettre à jour la fiche' : duplicates.hasSimilar ? 'Créer quand même' : 'Créer le candidat';

  const title = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box sx={{ width: 38, height: 38, borderRadius: '10px', bgcolor: '#ebf4fb', color: '#03407b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <PersonAddAlt1OutlinedIcon />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>Ajouter au CRM</Typography>
        <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>Vérifiez les informations extraites du CV avant de créer le candidat.</Typography>
      </Box>
    </Box>
  );

  return (
    <Modal
      open={open}
      onClose={() => !loading && onClose()}
      title={title}
      maxWidth="sm"
      actions={
        <>
          <AppButton variant="secondary" onClick={onClose} disabled={loading}>Annuler</AppButton>
          <AppButton startIcon={<PersonAddAlt1OutlinedIcon />} loading={loading} disabled={(!form.nom && !form.prenom) || duplicates.loading} onClick={() => onSubmit(form)}>
            {submitLabel}
          </AppButton>
        </>
      }
    >
      <Box sx={{ mb: 2 }}><DuplicateCandidates check={duplicates} /></Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.75, pt: 0.5 }}>
        {FIELDS.map((f) => (
          <Box key={f.key} sx={{ gridColumn: f.full ? '1 / -1' : 'auto' }}>
            <Typography component="label" sx={{ display: 'block', mb: 0.6, fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: '#64748b' }}>
              {f.label}
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={form[f.key]}
              onChange={(e) => setForm((p) => ({ ...p, [f.key]: e.target.value }))}
              disabled={loading}
            />
          </Box>
        ))}
      </Box>
    </Modal>
  );
};

export default AddToCrmModal;
